<template>
    <v-dialog v-model="modal" width="800px" max-width="100%">
        <v-card v-if="info" width="800px" max-width="100%" class="pa-md-3">
            <v-icon class="v-card-close" @click="modal = false">mdi-close</v-icon>
            <v-card-text class="text-black">
                <h2>
                    {{ info.name }}
                </h2>
                <div v-if="info.location" class="text-subtitle-2">
                    {{ info.location }}
                </div>
                <v-tabs
                    v-if="
                        (info.images && info.images.length) ||
                        (info.descriptions && info.descriptions.length) ||
                        (info.comments && info.comments.length) ||
                        info.fullDescription ||
                        info.shortDescription
                    "
                    v-model="tab"
                >
                    <v-tab>
                        {{ $t('description') }}
                    </v-tab>
                </v-tabs>
                <v-window v-model="tab">
                    <v-window-item>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-carousel
                                    height="170px"
                                    hide-delimiters
                                    :show-arrows="info.images && info.images.length > 1 ? 'hover' : false"
                                >
                                    <v-carousel-item v-for="(image, imageIndex) in info.images" :key="imageIndex">
                                        <v-img :src="$filters.imageUrl(image.url, 300)" cover />
                                    </v-carousel-item>
                                </v-carousel>
                            </v-col>
                            <v-col cols="12" md="8">
                                <template v-if="offer.serviceDescription">
                                    <div class="font-weight-bold">{{ $t('description') }}</div>
                                    <div v-html="offer.serviceDescription" />
                                </template>
                                <div v-if="info.comments && info.comments.length">
                                    <strong> {{ $t('comments') }} </strong><br />
                                    <div v-for="(comment, commentIndex) in info.comments" :key="commentIndex">
                                        {{ comment.title }}: {{ comment.description }}
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-window-item>
                </v-window>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import ActivityMap from '@/components/activities/search/ActivityMap.vue'
    import {EventBus, SHOW_ACTIVITIES_INFO_MODAL} from '@/utils/event-bus'

    //TODO Need refactoring with other products
    @Component({
        components: {
            ActivityMap,
        },
    })
    export class ActivityInfoModal extends Vue {
        info = null
        offer = null
        modal = false
        conditionsInfo = {}
        tab = null

        mounted() {
            EventBus.$on(SHOW_ACTIVITIES_INFO_MODAL, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_ACTIVITIES_INFO_MODAL, this.showModal)
        }

        showModal({offer, info}) {
            this.offer = offer
            this.info = info
            this.modal = true
        }

        get mapPoints() {
            return []
        }
    }

    export default ActivityInfoModal
</script>
